export default __webpack_public_path__ + "44832a0668e9344c659e9b3047b6b424.jpg";